export enum PosthogEvent {
  BUTTON_CLICKED = "button_clicked",
  WALLET_CONNECTED = "wallet_connected",
  WALLET_CONNECTED_ERROR = "wallet_connected_error",
  BORROWED = "borrowed",
  BORROW_ERROR = "borrow_error",
  BORROW_MATS_CLAIMED = "musd_mats_claimed",
  BORROW_MATS_CLAIM_ERROR = "musd_mats_claim_error",
  BORROW_MORE_INCREASE_COLL = "get_more_mUSD-increase_coll-success",
  BORROW_MORE_INCREASE_COLL_ERROR = "get_more_mUSD-increase_coll-error",
  BORROW_MORE_REDUCE_RATIO = "get_more_mUSD-reduce_CR-success",
  BORROW_MORE_REDUCE_RATIO_ERROR = "get_more_mUSD-reduce_CR-error",
  BORROW_MORE_BUTTON_CLICKED = "get_more_muSD",
  BORROW_MORE_BALANCE_CONFIRMED = "get_more_mUSD-step_2",
  BORROW_MORE_STRATEGY_INCREASE_COLL = "get_more_mUSD-increase_coll-step_3",
  BORROW_MORE_STRATEGY_REDUCE_RATIO = "get_more_mUSD-reduce_CR-step_3",
  BORROW_MORE_CONFIRM_INCREASE_COLL = "get_more_mUSD-increase_coll-step_4",
  BORROW_MORE_CONFIRM_REDUCE_RATIO = "get_more_mUSD-reduce_CR-step_4",
  BORROW_REPAY_STARTED = "loan_repay_started",
  BORROW_REPAY_ERROR = "loan_repaid_error",
  BORROW_REPAY = "loan_repaid",
  BORROW_COLLATERAL_DEPOSIT_STARTED = "deposit_collateral_started",
  BORROW_COLLATERAL_DEPOSIT_ERROR = "deposit_collateral_error",
  BORROW_COLLATERAL_DEPOSIT = "deposited_collateral_success",
  BORROW_COLLATERAL_WITHDRAW_STARTED = "withdraw_collateral_started",
  BORROW_COLLATERAL_WITHDRAW_ERROR = "withdraw_collateral_error",
  BORROW_COLLATERAL_WITHDRAW = "withdrawn_collateral_success",
  MATS_CONVERTED = "mats_converted",
  TAHO_WALLET_CONNECTED = "taho_wallet_connected",
  SIGN_UP_REWARDS_CLAIMED = "sign_up-reward_claimed",
  SIGN_UP_STARTED = "sign_up-started",
  SIGN_UP_COMPLETED = "sign_up-completed",
  SIGN_UP_DISCORD_ADDED = "sign_up-discord_added",
  USERNAME_SET = "username_set",
  DEPOSIT_OPT_OUT = "deposit_opt-out",
  DEPOSIT_OPT_IN = "deposit_opt-in",
  MARKET_TRANSACTION_ERROR = "market_transaction_error",
  MARKET_DONATION_SUCCESS = "donation_success",
  MARKET_PURCHASE_SUCCESS = "purchase_success",
  SWITCH_TO_TESTNET = "switch_to_testnet-clicked",
  ADD_FUNDS_STARTED = "add_funds-started",
  ADD_FUNDS_COMPLETED = "add_funds-completed",
}

export enum PosthogAnalyticsId {
  MATS_EXPLORE = "mats-explore_cta-ab5",
  ASSETS_BRIDGE = "assets-bridge_cta-ab3",
  ASSETS_ADD_FUNDS = "assets-add_funds_cta-ab1",
  MUSD_BORROW = "musd-borrow_cta-ab2",
  ONBOARDING_SIGNIN = "nav-sign_in-nb3",
  ETHEREUM_WALLET = "onboarding-siw_eth_wallet-om1",
  BITCOIN_WALLET = "onboarding-siw_btc_wallet-om2",
  ONBOARDING_SIGNUP = "onboarding-signup-om3",
  TAHO_WALLET = "onboarding-siw_injected-om4",
  METAMASK_WALLET = "onboarding-siw_metamask-om5",
  ZERION_WALLET = "onboarding-siw_zerion-om6",
  OKX_WALLET = "onboarding-siw_okx_eth-om7",
  UNISAT_WALLET = "onboarding-siw_unisat-om8",
  OKX_BTC_WALLET = "onboarding-siw_okx-om9",
  XVERSE_WALLET = "onboarding-siw_xverse-om10",
}

// TODO: Posthog feature flags proven to be difficult in the QA process as they
// are sometimes not loading correctly for the first time and they can be blocked
// by browsers or extensions. We should reconsider how we use them in the future,
// either by fixing the issues or by using these flags for A/B testing only.
export enum PosthogFeatureFlag {}

export type BorrowRepayPosthogEventProps = {
  repayment_strategy: string
  collateral: number
  collateral_change: number
  collateralization_ratio: number
  collateralization_change: number
  repayment_amount: number
  full_repayment: boolean
  accrued_interest: number
  debt_repaid: number
  remaining_debt: number
}

export type BorrowCollateralChangePosthogEventProps = {
  collateral: number
  prev_collateral: number
  collateralization_ratio: number
  prev_collateralization_ratio: number
}
